import React, { ReactNode } from 'react';
import { Modal } from 'react-bootstrap';
import Button from './Button';

interface IProps {
  show: boolean;
  onHide: () => void;
  title: string;
  children: ReactNode;
  onConfirm: () => void;
  confirmButtonLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

function ConfirmationDialog({
  show,
  onHide,
  title,
  children,
  onConfirm,
  confirmButtonLabel = 'Confirm',
  isLoading = false,
  disabled = false
}: IProps) {
  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="secondary">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="primary"
          loading={isLoading}
          loadingPosition="start"
          disabled={disabled || isLoading}
        >
          {confirmButtonLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationDialog;
